import { useEffect } from "react";

import { useThunkDispatch } from "@/store/hooks";
import { fetchOrganizationUsers } from "@/store/v2/organizationUsers/organizationUsersSlice";

interface OrganizationUsersData {
  organizationId?: number;
  hookEnabled?: boolean;
}

export function useOrganizationUsersData(props: OrganizationUsersData) {
  const { organizationId = 0, hookEnabled } = props;
  const dispatch = useThunkDispatch();

  const fetchOrgExperiences = () => {
    dispatch(fetchOrganizationUsers({ organizationId }));
  };

  useEffect(() => {
    if (hookEnabled) {
      fetchOrgExperiences();
    }
  }, [organizationId]);
}
